// App.js
import React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import SearchScreen from './components/Search';
import ResultsScreen from './components/Result';
import RestaurantDetailsScreen from './components/RestaurantDetails'
import Toast from 'react-native-toast-message';
import CommentComponent from './components/comments';

const Stack = createStackNavigator();

const App = () => {
  return (
    <NavigationContainer>
    <CommentComponent />
      <Stack.Navigator initialRouteName="Search">
        <Stack.Screen name="Search" component={SearchScreen} options={{ title: 'Recherche' }} />
        <Stack.Screen name="Results" component={ResultsScreen} options={{ title: 'Résultats' }} />
        <Stack.Screen
        name="RestaurantDetails"
        component={RestaurantDetailsScreen}
        options={{ title: "Détails du restaurant"}}
        />
      </Stack.Navigator>
      <Toast ref={(ref) => Toast.setRef(ref)} />
    </NavigationContainer>
  );
};



export default App;
